import React from 'react';
import { Card } from '@/components/ui/cards/Card';
import { Skeleton } from '@/components/ui/loading';
import { DonutChart } from '@/components/ui/charts/DonutChart';


interface DonutSummaryCardSkeletonProps {
  rows?: number;
  'data-testid'?: string;
}

export const DonutSummaryCardSkeleton: React.FC<DonutSummaryCardSkeletonProps> = ({
  rows = 3,
  'data-testid': dataTestId,
}) => (
  <Card
    elevation={1}
    borderRadius="16px"
    padding="24px"
    style={{ display: 'flex', flexDirection: 'column', gap: 12, flex: 1, minWidth: 280 }}
    data-testid={dataTestId}
  >
    <Skeleton width={140} height={16} data-testid={`${dataTestId}-title`} />

    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, flex: 1 }}>
      <DonutChart size={195} strokeWidth={18} data-testid={`${dataTestId}-donut`} />

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, width: '100%' }}>
        {Array.from({ length: rows }, (_, index) => (
          <div
            key={index}
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
            data-testid={`${dataTestId}-row-${index}`}
          >
            <Skeleton width={80} height={12} data-testid={`${dataTestId}-row-${index}-label`} />
            <Skeleton width={50} height={12} data-testid={`${dataTestId}-row-${index}-value`} />
          </div>
        ))}
      </div>
    </div>
  </Card>
);

export default DonutSummaryCardSkeleton;
